import React from "react";
import backArrow from "../../assets/img/back_arrow.svg";
import formConfig from "../../config/formConfig";

const SummaryTyped = ({ formData, onPrevious, onNext }) => {
  const handleDone = (e) => {
    e.preventDefault();
    onNext(e);
  };

  // Filter out keys with no value
  // const filteredFormData = Object.keys(formData).filter(key => formData[key] !== undefined && formData[key] !== '');
  // Map keys to their corresponding questions
  // const questionMap = {};
  // Object?.values(formConfig).forEach(segment => {
  //   segment?.forEach(step => {
  //     questionMap[step.name] = step.question;
  //   });
  // });
  return (
    <div className="cus_form basic_question_box">
      <div className="custom_filed custom_basic">
        <div className="form-group">
          <div className="answer_summary">
            <div className="heading">
              <h3 style={{ textAlign: "left" }}>Answer Summary</h3>
              {formData?.map((item, index) => {
                if (item?.name && item?.answer != "") {
                  return (
                    <div className="question" key={index}>
                      <p style={{ textAlign: "left" }}>
                        {`${item?.question}`}</p>

                      <h3 style={{ textAlign: "left" }}>{`- ${item?.answer}`}</h3>
                    </div>
                  );
                }
              })}
            </div>
            <div className="next_btn basic_ques text-center">
              <button
                type="button"
                className="custom mt-0 mr-3"
                onClick={onPrevious}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  marginRight: 10,
                }}
              >
                <img className="back" src={backArrow} alt="Back" /> Back
              </button>
              <button
                type="submit"
                className="custom mt-0"
                style={{
                  backgroundColor: "#98272A",
                  color: "white",
                  marginLeft: 10,
                }}
                onClick={handleDone}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryTyped;
